import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import DialogModal from '../../../../common/DialogModal';
import Toolbar from 'material-ui/Toolbar';
import { DialogTitle } from 'material-ui/Dialog';
import Button from '../../../../Parts/Button';
import TreeSection from './TreeSection';
import { getAllLeafIds, sanitizeToLeafSet } from '../../../../../utils/treeUtils';

const { Set } = require('immutable');

const styles = () => ({
  paper: {
    background: '#F4F6F9',
    width: '85%',
  },

  contentContainer: {
    flex: 1,
    overflowY: 'auto',
    padding: 0,
    margin: 'unset',
  },

  guttersContainer: {
    position: 'sticky',
    top: 0,
    zIndex: 10,
    background: '#FFFFFF',
  },

  gutters: {
    fontSize: '15px',
    fontWeight: 700,
    borderBottom: '1px solid #D8DBDF',
    width: '100%',
    boxSizing: 'border-box',
  },

  dialogTitle: {
    padding: '0px',
    flex: 1,
    textAlign: 'left',
  },

  containerWrapper: {
    width: '100%',
    padding: '25px',
    boxSizing: 'border-box',
  },

  container: {
    background: '#FFFFFF',
    border: '1px solid #D8DBDF',
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px 20px 10px',
  },
});

/**
 * 階層構造のメニューを選択するダイアログ
 * 常に「葉ID」のみしかselectedItemsに入れない。が選択状況によって上層ノードが選択状態のUIになる
 */
class SelectHierarchicalMenuDialog extends React.Component {
  state = {
    selectedItems: Set(), // 常に「葉ID」のみ
  };

  componentDidMount() {
    const initial = sanitizeToLeafSet(this.props.set, this.props.hierarchicalMenu);
    if (!this.state.selectedItems.equals(initial)) {
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({ selectedItems: initial });
    }
    if (this.contentRef) {
      this.contentRef.addEventListener('scroll', this.handleScroll, false);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.set !== this.props.set || prevProps.hierarchicalMenu !== this.props.hierarchicalMenu) {
      const next = sanitizeToLeafSet(this.props.set, this.props.hierarchicalMenu);
      if (!this.state.selectedItems.equals(next)) {
        this.setState({ selectedItems: next });
      }
    }
  }

  componentWillUnmount() {
    if (this.contentRef) {
      this.contentRef.removeEventListener('scroll', this.handleScroll, false);
    }
  }

  handleScroll = () => {
    const maxScrollTop = 20;
    if (this.contentRef && this.titleRef && this.contentRef.scrollTop > maxScrollTop) {
      this.titleRef.style.boxShadow = '0px 1px 10px 0px rgba(0, 0, 0, 0.12)';
    } else {
      this.titleRef.style.boxShadow = 'none';
    }
  };

  setTitleRef = (node) => { this.titleRef = node; };
  setContentRef = (node) => { this.contentRef = node; };

  // 常に葉IDのみをトグル
  toggleNode = (node) => {
    if (!node) return;
    let selectedItems = this.state.selectedItems;
    if (!Set.isSet(selectedItems)) selectedItems = Set();

    const leafIds = getAllLeafIds(node);
    if (leafIds.length === 0) return;

    const allSelected = leafIds.every((id) => selectedItems.has(id));
    const next = allSelected
      ? selectedItems.subtract(leafIds)
      : selectedItems.union(leafIds);

    this.setState({ selectedItems: next });
  };

  render() {
    const { classes, toggleDialog, isOpen, title, hierarchicalMenu, contextData, colCount, headerContent } = this.props;
    const { selectedItems } = this.state;

    const itemsUnchanged = Set.isSet(this.props.set)
      ? selectedItems.equals(sanitizeToLeafSet(this.props.set, hierarchicalMenu))
      : false;
    const disableSave = itemsUnchanged && !this.props.hasExternalChanges;

    return (
      <DialogModal
        open={isOpen}
        onClose={toggleDialog}
        maxWidth={false}
        classes={{
          paper: classes.paper,
          contentContainer: classes.contentContainer,
        }}
      >
        <div ref={this.setTitleRef} className={classes.guttersContainer}>
          <Toolbar classes={{ gutters: classes.gutters }}>
            <DialogTitle className={classes.dialogTitle} disableTypography>
              {title}
            </DialogTitle>

            <Button
              text="条件をセット"
              handleClickButton={() => {
                this.props.save(selectedItems);
                toggleDialog();
              }}
              size="small"
              disabled={disableSave}
            />
          </Toolbar>
          {headerContent}
        </div>

        <div className={classes.containerWrapper} ref={this.setContentRef}>
          <div className={classes.container}>
            {Array.isArray(hierarchicalMenu) && hierarchicalMenu.length > 0
              ? hierarchicalMenu.map((root, idx) => (
                  <TreeSection
                    key={`root-${idx}`}
                    node={root}
                    level={0}
                    selectedItems={selectedItems}
                    onToggle={this.toggleNode}
                    colCount={colCount}
                    contextData={contextData}
                  />
                ))
              : null}
          </div>
        </div>
      </DialogModal>
    );
  }
}

SelectHierarchicalMenuDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  set: PropTypes.object, // Set<leafId>
  save: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  hierarchicalMenu: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string,
    children: PropTypes.array,
  })).isRequired,
  contextData: PropTypes.object,
  colCount: PropTypes.number,
  headerContent: PropTypes.node,
  hasExternalChanges: PropTypes.bool,
};

SelectHierarchicalMenuDialog.defaultProps = {
  colCount: 4,
  hasExternalChanges: false,
};

export default withStyles(styles)(SelectHierarchicalMenuDialog);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/SelectHierarchicalMenuDialog/common/SelectHierarchicalMenuDialog.jsx